<div
  class="app-header header-shadow"
  id="vbHeader"
  [class.is-inside-app]="(curPage | async) !== 'settings' && (curPage | async) !== 'dashboards'"
  [class.is-outside-app]="(curPage | async) === 'settings' || (curPage | async) === 'dashboards'"
  [class.is-chat-collapsed]="isChatCollapsed"
  [class.is-chat-expanded]="!isChatCollapsed"
  [class.is-beta-access-privilege-consumable]="isBetaAccessPrivilegeConsumable"
>
  <div
    class="d-flex justify-content-between align-items-center w-100 inner-header-container"
    [class.inner-header-container]="isBetaAccessPrivilegeConsumableForApp"
    [class.px-0]="!isBetaAccessPrivilegeConsumable"
  >
    <div
      class="app-header__logo"
      [ngClass]="{ 'logo-wid': (curPage | async) === 'settings' || (curPage | async) === 'dashboards' }"
      *ngIf="!isBetaAccessPrivilegeConsumableForApp && !isMenuCollapsed"
    >
      <rt-product-logo
        width="75"
        height="33"
        class="cursor-pointer"
        (click)="onLogoClick()"
        (keydown.enter)="onLogoClick()"
        tabindex="0"
      ></rt-product-logo>
    </div>


     <div
      class="app-header__logo"
      *ngIf="!isBetaAccessPrivilegeConsumableForApp && isMenuCollapsed"
    >
     <img
        src="assets/images/svg/logo.svg"
        alt="Rappit Logo"
        class="rappit-logo cursor-pointer logo_margin"
        height="25"
        (click)="onLogoClick()"
        (keydown.enter)="onLogoClick()"
        tabindex="0"
      />
    </div>


    <div class="d-flex flex-shrink-0 align-items-center logo-container" *ngIf="isBetaAccessPrivilegeConsumableForApp">
      <rt-product-logo
        width="75"
        height="33"
        class="cursor-pointer"
        (click)="navigateToHome()"
        (keydown.enter)="navigateToHome()"
        tabindex="0"
      ></rt-product-logo>

      <div
        class="d-flex align-items-center gap-2 chat-actions-wrapper"
        *ngIf="(curPage | async) !== 'settings' && (curPage | async) !== 'dashboards'  && !isChatCollapsed"
      >
        <button
          class="icon-btn-small"
          [class.active]="isSessionsPanelOpen"
          title="Sessions"
          (click)="openSessionsPanel()"
        >
          <rt-inbox-icon [width]="20" [height]="20"></rt-inbox-icon>
        </button>
        <button
          class="icon-btn-small"
          [class.active]="isNewSessionActive"
          title="Create session"
          (click)="createNewSession()"
        >
          <rt-message-icon [width]="20" [height]="20"></rt-message-icon>
        </button>
        <button class="icon-btn-small" title="Toggle chat" (click)="toggleChat()">
          <rt-toggle-view-icon [width]="20" [height]="20"></rt-toggle-view-icon>
        </button>
      </div>
    </div>

    <div class="app-header__content">
      <div class="app-header-left">
        <div class="widget-content p-0" *ngIf="!isBetaAccessPrivilegeConsumableForApp">
          <div class="widget-content-wrapper">

            <div
              class="widget-content-left pl-1 pr-1 control-icons cursor-pointer"
              *ngIf="(curPage | async) !== 'settings' && (curPage | async) !== 'dashboards'"
            >
              <span
                class="header-icon-container"
                (click)="$event.stopPropagation(); backToHome()"
                (keydown.enter)="$event.stopPropagation(); backToHome()"
                tabindex="0"
                role="button"
                aria-label="Back to home"
              >
                <i class="fa fa-home" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>

        <div
          class="d-inline-block dropdown app-name-selector"
          *ngIf="(curPage | async) !== 'settings' && (curPage | async) !== 'dashboards'"
        >
          <p-select
            *ngIf="apps && apps.length >= 1 && !(apps.length === 1 && !isSearchquery)"
            [options]="apps"
            #dropdownEle
            [styleClass]="'appname-dropdown'"
            panelStyleClass="appname-dropdown-panel"
            [(ngModel)]="selectedApp"
            optionLabel="name"
            [filter]="true"
            filterBy="name"
            [placeholder]="selectedAppDispName"
            (onChange)="handleAppSelectionChange($event)"
            (onFilter)="search($event)"
            [disabled]="config.flags.isApp_MergeStatus_InProgress"
          >
            <ng-template pTemplate="selectedItem">
              <div class="country-item country-item-value" *ngIf="selectedApp">
                <div [title]="selectedApp.name">
                  {{ selectedApp.name }}
                </div>
              </div>
            </ng-template>
            <ng-template let-app pTemplate="item">
              <div class="country-item" [title]="app?.suiteName ? app.suiteName + ' ' + app.name : app.name">
                <div class="app-item-label">
                  <span class="font-weight-bold mr-2" *ngIf="app?.suiteName">{{ app?.suiteName }}</span
                  >{{ app.name }}
                </div>
              </div>
            </ng-template>
            <span>Loader</span>
          </p-select>
          <span class="app_org_name" *ngIf="apps && apps.length === 1 && !isSearchquery">{{ selectedApp.name }}</span>
        </div>
        <vb-branch-dropdown-header
          class="app-branch-selector"
          *ngIf="(curPage | async) !== 'settings' && showBranchDropdown && (curPage | async) !== 'dashboards'"
          [config]="config"
        ></vb-branch-dropdown-header>
      </div>

      <div
        class="artifacts-toggle"
        *ngIf="
          (curPage | async) !== 'settings' &&
          (curPage | async) !== 'dashboards' &&
          isBetaAccessPrivilegeConsumableForApp
        "
      >
        <button
          class="artifacts-toggle-btn"
          [class.active]="activeArtifactTab === 'blueprint'"
          (click)="switchArtifactTab('blueprint')"
          [attr.data-item-name]="'blueprint'"
          [pTooltip]="activeArtifactTab === 'blueprint' ? '' : 'Blueprint'"
          tooltipPosition="bottom"
          tooltipStyleClass="bp-dark-tooltip"
          type="button"
        >
          <rt-compass-icon></rt-compass-icon>
          <span *ngIf="activeArtifactTab === 'blueprint'">Blueprint</span>
        </button>
        <button
          class="artifacts-toggle-btn"
          [class.active]="activeArtifactTab === 'build'"
          (click)="switchArtifactTab('build')"
          [attr.data-item-name]="'build'"
          [pTooltip]="activeArtifactTab === 'build' ? '' : 'Build'"
          tooltipPosition="bottom"
          tooltipStyleClass="bp-dark-tooltip"
          type="button"
        >
          <rt-cube-icon [width]="20" [height]="20"></rt-cube-icon>
          <span *ngIf="activeArtifactTab === 'build'">Build</span>
        </button>
        <button
          class="artifacts-toggle-btn"
          [class.active]="activeArtifactTab === 'code'"
          (click)="switchArtifactTab('code')"
          [attr.data-item-name]="'code'"
          [pTooltip]="activeArtifactTab === 'code' ? '' : 'Code'"
          tooltipPosition="bottom"
          tooltipStyleClass="bp-dark-tooltip"
          type="button"
        >
          <rt-code-icon [width]="20" [height]="20"></rt-code-icon>
          <span *ngIf="activeArtifactTab === 'code'">Code</span>
        </button>
        <button
          class="artifacts-toggle-btn"
          [class.active]="activeArtifactTab === 'test'"
          (click)="switchArtifactTab('test')"
          [attr.data-item-name]="'test'"
          [pTooltip]="activeArtifactTab === 'test' ? '' : 'Test'"
          tooltipPosition="bottom"
          tooltipStyleClass="bp-dark-tooltip"
          type="button"
        >
          <rt-clipboard-check-icon [width]="20" [height]="20"></rt-clipboard-check-icon>
          <span *ngIf="activeArtifactTab === 'test'">Test</span>
        </button>
        <button
          class="artifacts-toggle-btn"
          [class.active]="activeArtifactTab === 'operate'"
          (click)="switchArtifactTab('operate')"
          [attr.data-item-name]="'operate'"
          [pTooltip]="activeArtifactTab === 'operate' ? '' : 'Operate'"
          tooltipPosition="bottom"
          tooltipStyleClass="bp-dark-tooltip"
          type="button"
        >
          <rt-rocket-icon [width]="20" [height]="20"></rt-rocket-icon>
          <span *ngIf="activeArtifactTab === 'operate'">Operate</span>
        </button>
      </div>

      <div class="app-header-right">
        <div
          class="d-inline-block dropdown orgSelection pl-3 pr-3 py-0 ml-auto"
          *ngIf="(curPage | async) === 'settings' || (curPage | async) === 'dashboards'"
        >
          <p-select
            *ngIf="userOrgs && userOrgs.length > 1"
            [options]="orgs"
            #dropdownEle1
            (onShow)="onDropdownShow()"
            (onHide)="orgDropdownHidden()"
            [styleClass]="'appname-dropdown'"
            [(ngModel)]="selectedOrg"
            [disabled]="userOrgs.length === 1"
            optionLabel="name"
            [filter]="true"
            filterBy="name"
            [filterValue]="searchTextOrg"
            placeholder="Select an Organization"
            (onChange)="handleOrgSelectionChange($event)"
            (onFilter)="searchOrg($event)"
            showDelay="100"
            hideDelay="100"
            pTooltip="Organization Name"
            tooltipStyleClass="label-tooltip"
            tooltipPosition="bottom"
            appendTo="body"
            panelStyleClass="header-dropdown-panel"
          >
            <ng-template pTemplate="selectedItem">
              <div class="item-value" *ngIf="selectedOrg">
                <div>{{ selectedOrg.name }}</div>
              </div>
            </ng-template>
            <ng-template let-item pTemplate="item">
              <div class="org-dropdown-item" [pTooltip]="item.name" tooltipPosition="left">
                {{ item.name }}
              </div>
            </ng-template>
            <ng-template pTemplate="empty">
              <div class="loader-container" *ngIf="headerLoader">
                <p-progress-spinner></p-progress-spinner>
              </div>
              <div *ngIf="headerEmpMsg" class="emptyMsgContainer">
                {{ 'NO_RECORDS_FOUND' | translate }}
              </div>
            </ng-template>
          </p-select>

          <span
            class="app_org_name"
            *ngIf="userOrgs && userOrgs.length === 1"
            showDelay="100"
            hideDelay="100"
            pTooltip="Organization Name"
            tooltipStyleClass="label-tooltip"
            tooltipPosition="bottom"
            appendTo="body"
            >{{ selectedOrg.name }}</span
          >
        </div>

        <div class="header-btn-lg pr-0">
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div
                class="merge-status-banner"
                *ngIf="
                  targetBranchCreationInProgress &&
                  (curPage | async) !== 'settings' &&
                  (curPage | async) !== 'dashboards'
                "
                pTooltip="{{ 'TARGET_BRANCH_CREATION_IN_PROGRESS' | translate }}"
                tooltipPosition="bottom"
              >
                <i class="pi pi-exclamation-triangle merge-icon"></i>
                <span class="merge-text">{{ 'BRANCH_CREATION_IN_PROGRESS_BANNER_TEXT' | translate }}</span>
              </div>

              <!-- Merge Status Banner - Show for review phase -->
              <div
                class="merge-status-banner"
                *ngIf="
                  mergeStatusInfo &&
                  mergeStatusInfo.status === 'MERGE_CHANGES_REVIEW_IN_PROGRESS' &&
                  (curPage | async) !== 'settings' &&
                  (curPage | async) !== 'dashboards'
                "
                (click)="showMergeDetailsPopup()"
                (keydown.enter)="showMergeDetailsPopup()"
                tabindex="0"
                pTooltip="Click for details"
                tooltipPosition="bottom"
              >
                <i class="pi pi-exclamation-triangle merge-icon"></i>
                <span class="merge-text"
                  >{{ 'MERGE_INITIATED_BY' | translate }} {{ mergeStatusInfo?.initiatedBy }}</span
                >
              </div>

              <!-- Merge Status Banner - Show during actual merge -->
              <div
                class="merge-status-banner"
                *ngIf="
                  mergeStatusInfo &&
                  (mergeStatusInfo.status === 'MERGE_PROCESS_IN_PROGRESS' ||
                    mergeStatusInfo.status === 'MERGE_VALIDATION_IN_PROGRESS' ||
                    mergeStatusInfo.status === 'MERGE_TAG_CREATION_STARTED' ||
                    mergeStatusInfo.status === 'PUBLISH_PROCESS_STARTED')
                "
                (click)="showMergeDetailsPopup()"
                (keydown.enter)="showMergeDetailsPopup()"
                tabindex="0"
                pTooltip="Click for details"
                tooltipPosition="bottom"
              >
                <i class="pi pi-spin pi-spinner merge-icon"></i>
                <span class="merge-text">{{ 'MERGE_IN_PROGRESS' | translate }}</span>
              </div>

              <div
                class="progress-bar"
                *ngIf="
                  showProgressBar &&
                  (curPage | async) !== 'settings' &&
                  (curPage | async) !== 'dashboards' &&
                  !isBetaAccessPrivilegeConsumableForApp
                "
              >
                <p class="pl-1 publishing">
                  {{ 'PUBLISHING' | translate }}
                </p>
                <p-progressBar [value]="value"></p-progressBar>
              </div>

              <div
                class="split-container"
                *ngIf="
                  (curPage | async) !== 'settings' &&
                  (curPage | async) !== 'dashboards' &&
                  !targetBranchCreationInProgress &&
                  !mergeStatusInfo &&
                  showPublish &&
                  !spinner &&
                  !showProgressBar &&
                  userRole !== 'Viewer' &&
                  userRole !== 'Prototype Viewer' &&
                  !isBetaAccessPrivilegeConsumableForApp &&
                  !isTag
                "
                [class.menu-disabled]="isCloneInProgress"
                [pTooltip]="isCloneInProgress ? ('CLONING_IN_PROGRESS_TOOLTIP' | translate) : ''"
                tooltipPosition="bottom"
              >
                <div class="dropdown publish-menu">
                  <button
                    class="btn btn-publish dropdown-toggle"
                    type="button"
                    id="dropdownMenu"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    (click)="getPublishStatus()"
                    [disabled]="isCloneInProgress"
                  >
                    {{ 'PUBLISH' | translate }}
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenu">
                    <div class="dropdown-item">
                      <div
                        class="d-flex flex-column menu-item"
                        (click)="showConfirmPublish('PROTOTYPE')"
                        (keyup.enter)="showConfirmPublish('PROTOTYPE')"
                        tabindex="0"
                        role="button"
                        aria-label="Confirm Publish"
                      >
                        <button class="menu-btn" type="button">{{ 'PUBLISH_PROTOTYPE' | translate }}</button>
                        <div
                          class="d-flex justify-content-between last-publish align-items-center"
                          *ngIf="lastCompletedPublishData?.prototype"
                        >
                          <div class="left-content align-items-center">
                            <span>{{ 'LAST_PUBLISH' | translate }}</span>
                          </div>
                          <div class="ml-2 right-content align-items-center">
                            <span class="mr-1">{{
                              lastCompletedPublishData.prototype.modifiedDate | date: 'MMM d, hh:mm a'
                            }}</span>
                            <p-avatar
                              [label]="lastCompletedPublishData?.prototype?.avatarImage?.character"
                              shape="circle"
                              pTooltip="{{ lastCompletedPublishData.prototype.name }}"
                              tooltipPosition="bottom"
                              [style]="{
                                'background-color': lastCompletedPublishData?.prototype?.avatarImage?.color,
                                color: '#fff'
                              }"
                              appendTo="body"
                            ></p-avatar>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="dropdown-item">
                      <div
                        class="d-flex flex-column menu-item publish-code-git-item"
                        (click)="showConfirmPublish('PUSH')"
                        (keyup.enter)="showConfirmPublish('PUSH')"
                        tabindex="0"
                        role="menuitem"
                      >
                        <button class="menu-btn" type="button">{{ 'PUBLISH_CODE_GIT' | translate }}</button>
                        <div
                          class="publish-sub-options"
                          role="menu"
                          *ngIf="lastCompletedPublishData?.push || lastCompletedPublishData?.prototype"
                        >
                          <div
                            class="d-flex justify-content-between align-items-center sub-option"
                            *ngIf="lastCompletedPublishData?.push"
                            aria-label="Git Publish - Push code to Git repository"
                          >
                            <div class="left-content align-items-center">
                              <span>{{ 'GIT_PUBLISH' | translate }}</span>
                            </div>
                            <div class="ml-2 right-content align-items-center" *ngIf="lastCompletedPublishData?.push">
                              <span class="mr-1">{{
                                lastCompletedPublishData.push.gitPushTime || lastCompletedPublishData.push.modifiedDate
                                  | date: 'MMM d, hh:mm a'
                              }}</span>
                              <p-avatar
                                [label]="lastCompletedPublishData?.push?.avatarImage?.character"
                                pTooltip="{{ lastCompletedPublishData.push.name }}"
                                tooltipPosition="bottom"
                                shape="circle"
                                [style]="{
                                  'background-color': lastCompletedPublishData?.push?.avatarImage?.color,
                                  color: '#fff'
                                }"
                                appendTo="body"
                              ></p-avatar>
                            </div>
                          </div>
                          <div class="d-flex align-items-center sub-option" *ngIf="lastCompletedPublishData?.prototype">
                            <div class="left-content align-items-center">
                              <span>{{ 'PROTOTYPE_PUBLISH' | translate }}</span>
                            </div>
                            <div class="ml-2 right-content align-items-center" [class.always-visible]="spinner">
                              <ng-container
                                *ngIf="
                                  spinner || lastCompletedPublishData?.prototype?.compilationStatus === null;
                                  else prototypePublishTime
                                "
                              >
                                <span class="in-progress-label">{{ 'IN_PROGRESS' | translate }}</span>
                              </ng-container>
                              <ng-template #prototypePublishTime>
                                <ng-container *ngIf="lastCompletedPublishData?.prototype">
                                  <span class="mr-1">{{
                                    lastCompletedPublishData.prototype.modifiedDate | date: 'MMM d, hh:mm a'
                                  }}</span>
                                  <p-avatar
                                    [label]="lastCompletedPublishData?.prototype?.avatarImage?.character"
                                    pTooltip="{{ lastCompletedPublishData.prototype.name }}"
                                    tooltipPosition="bottom"
                                    shape="circle"
                                    [style]="{
                                      'background-color': lastCompletedPublishData?.prototype?.avatarImage?.color,
                                      color: '#fff'
                                    }"
                                    appendTo="body"
                                  ></p-avatar>
                                </ng-container>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="dropdown-item">
                      <div
                        class="menu-item"
                        (click)="showConfirmPublish('PULL')"
                        (keyup.enter)="showConfirmPublish('PULL')"
                        tabindex="0"
                        role="button"
                        aria-label="Show Confirm Publish"
                      >
                        <button class="menu-btn" type="button">{{ 'GET_CUSTOMIZATION_GIT' | translate }}</button>
                        <div
                          class="d-flex justify-content-between last-publish align-items-center"
                          *ngIf="lastCompletedPublishData?.pull"
                        >
                          <div class="left-content align-items-center">
                            <span>{{ 'LAST_PUBLISH' | translate }}</span>
                          </div>
                          <div class="ml-2 right-content align-items-center">
                            <span class="mr-1">{{
                              lastCompletedPublishData.pull.modifiedDate | date: 'MMM d, hh:mm a'
                            }}</span>
                            <p-avatar
                              pTooltip="{{ lastCompletedPublishData.pull.name }}"
                              tooltipPosition="bottom"
                              [label]="lastCompletedPublishData?.pull?.avatarImage?.character"
                              shape="circle"
                              [style]="{
                                'background-color': lastCompletedPublishData?.pull?.avatarImage?.color,
                                color: '#fff'
                              }"
                              appendTo="body"
                            ></p-avatar>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="dropdown-item">
                      <div
                        class="menu-item"
                        (click)="showConfirmPublish('PUSH_UI_LIBRARIES')"
                        (keyup.enter)="showConfirmPublish('PUSH_UI_LIBRARIES')"
                        tabindex="0"
                        aria-label="Publish UI Libraries to Git"
                        [pTooltip]="'PUBLISH_UI_LIB_GIT_TOOLTIP' | translate: { version: productVersion }"
                        tooltipPosition="left"
                        tooltipStyleClass="publish-lib-tooltip"
                        appendTo="body"
                        showDelay="200"
                        hideDelay="100"
                      >
                        <button class="menu-btn" type="button">
                          {{ 'PUBLISH_UI_LIB_GIT' | translate }}
                        </button>
                        <div
                          class="d-flex justify-content-between last-publish align-items-center"
                          *ngIf="lastCompletedPublishData?.uiLibPush"
                        >
                          <div class="left-content align-items-center">
                            <span>{{ 'LAST_PUBLISH' | translate }}</span>
                          </div>
                          <div class="ml-2 right-content align-items-center">
                            <span class="mr-1">{{
                              lastCompletedPublishData.uiLibPush.modifiedDate | date: 'MMM d, hh:mm a'
                            }}</span>
                            <p-avatar
                              pTooltip="{{ lastCompletedPublishData.uiLibPush.name }}"
                              tooltipPosition="bottom"
                              [label]="lastCompletedPublishData?.uiLibPush?.avatarImage?.character"
                              shape="circle"
                              [style]="{
                                'background-color': lastCompletedPublishData?.uiLibPush?.avatarImage?.color,
                                color: '#fff'
                              }"
                              appendTo="body"
                            ></p-avatar>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="dropdown-item">
                      <div
                        class="menu-item"
                        (click)="showConfirmPublish('PUSH_BE_LIBRARIES')"
                        (keyup.enter)="showConfirmPublish('PUSH_BE_LIBRARIES')"
                        tabindex="0"
                        aria-label="Publish Backend Libraries to Git"
                        [pTooltip]="'PUBLISH_BE_LIB_GIT_TOOLTIP' | translate: { version: beLibraryVersion }"
                        tooltipPosition="left"
                        tooltipStyleClass="publish-lib-tooltip"
                        appendTo="body"
                        showDelay="200"
                        hideDelay="100"
                      >
                        <button class="menu-btn" type="button">
                          {{ 'PUBLISH_BE_LIB_GIT' | translate }}
                        </button>
                        <div
                          class="d-flex justify-content-between last-publish align-items-center"
                          *ngIf="lastCompletedPublishData?.beLibPush"
                        >
                          <div class="left-content align-items-center">
                            <span>{{ 'LAST_PUBLISH' | translate }}</span>
                          </div>
                          <div class="ml-2 right-content align-items-center">
                            <span class="mr-1">{{
                              lastCompletedPublishData.beLibPush.modifiedDate | date: 'MMM d, hh:mm a'
                            }}</span>
                            <p-avatar
                              pTooltip="{{ lastCompletedPublishData.beLibPush.name }}"
                              tooltipPosition="bottom"
                              [label]="lastCompletedPublishData?.beLibPush?.avatarImage?.character"
                              shape="circle"
                              [style]="{
                                'background-color': lastCompletedPublishData?.beLibPush?.avatarImage?.color,
                                color: '#fff'
                              }"
                              appendTo="body"
                            ></p-avatar>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="bell-icon"
                (click)="viewNotification()"
                (keyup.enter)="viewNotification()"
                tabindex="0"
                role="button"
                aria-label="Show Confirm Publish"
                *ngIf="
                  (curPage | async) !== 'settings' &&
                  (curPage | async) !== 'dashboards' &&
                  !spinner &&
                  !showProgressBar &&
                  !isBetaAccessPrivilegeConsumableForApp
                "
              >
                <span>
                  <svg-icon src="assets\images\svg\bell.svg"></svg-icon>
                </span>
              </div>

              <div
                class="widget-content-left pl-1 pr-1 control-icons cursor-pointer"
                *ngIf="
                  (curPage | async) !== 'settings' &&
                  (curPage | async) !== 'dashboards' &&
                  !isBetaAccessPrivilegeConsumableForApp
                "
              >
                <span
                  class="header-icon-container"
                  *ngIf="!spinner && (isPrototypePublished || showEyeIcon)"
                  showDelay="100"
                  hideDelay="100"
                  tooltipPosition="bottom"
                  alt="Zoom Out"
                >
                  <i
                    class="fa fa-eye"
                    aria-hidden="true"
                    (click)="openPrototypeInNewTab()"
                    (keydown.enter)="openPrototypeInNewTab()"
                  ></i>
                </span>

                <span
                  class="header-icon-container"
                  *ngIf="spinner"
                  style="text-align: center"
                  showDelay="100"
                  hideDelay="100"
                  pTooltip="{{ 'APP_IS_GENERATING' | translate }}"
                  tooltipStyleClass="label-tooltip"
                  tooltipPosition="bottom"
                >
                  <div *ngIf="spinner">
                    <div
                      *ngIf="spinner"
                      class="spinner-border"
                      style="
                        border: 0.1rem solid #1a73e8;
                        width: 10px;
                        height: 10px;
                        border-right-color: transparent;
                        vertical-align: middle;
                      "
                    ></div>
                  </div>
                </span>

                <span class="header-icon-container d-none" *ngIf="appToBeGenerated">
                  <img
                    src="assets\images\icon_generate.png"
                    showDelay="100"
                    hideDelay="100"
                    tooltipStyleClass="label-tooltip"
                    pTooltip="{{ 'GENERATE_APP' | translate }}"
                    tooltipPosition="bottom"
                    class="icon-style"
                    alt="Zoom In"
                    (click)="generateApp()"
                    (keyup.enter)="generateApp()"
                    tabindex="0"
                    role="button"
                    aria-label="Generate App"
                  />
                </span>
              </div>

              <div class="widget-content-left mr-1" [class.d-none]="isBetaAccessPrivilegeConsumable">
                <div class="btn-group">
                  <a aria-expanded="false" class="p-0 btn">
                    <p-avatar
                      [label]="avatarImage?.character"
                      shape="circle"
                      [style]="{ 'background-color': avatarImage?.color, color: '#fff' }"
                      (onFilter)="searchOrg($event)"
                      showDelay="100"
                      hideDelay="100"
                      pTooltip="{{ loggedInUser }}"
                      tooltipStyleClass="label-tooltip custom-tooltip-header-avatar"
                      tooltipPosition="left"
                      appendTo="body"
                    ></p-avatar>
                  </a>
                </div>
              </div>
              <div class="widget-content-right header-user-info ml-3" [class.d-none]="isBetaAccessPrivilegeConsumable">

                <button type="button" tabindex="0" aria-haspopup="true" class="cursor-pointer settings"
                  (click)="userMenu.toggle($event); hideDropdown()">
                  <span class="header-icon-container mr-0">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </span>
                </button>

                <p-popover #userMenu [dismissable]="true" styleClass="eva-v2-dropdown-list">
                  <ul class="nav flex-column eva-v2-dropdown">
                    <li class="nav-item" *ngFor="let menu of menuJSON">

                      <a *ngIf="!menu.children" class="nav-link" (click)="navigateMenu(menu); userMenu.hide()"
                        (keyup.enter)="navigateMenu(menu); userMenu.hide()" tabindex="0" aria-label="Navigate menu">
                        <svg-icon [src]="menu.src"></svg-icon>
                        <span>{{ menu.label | translate }}</span>
                      </a>

                      <div *ngIf="menu.children" class="menu-item-header nav-item nav-bg-hover-white border-top rounded-0">
                        <span class="nav-link nav-bg-hover-white text-muted fw-bold pl-0">
                          <span>{{ menu.label | translate }}</span>
                        </span>
                        <ul class="nav flex-column">
                          <li class="nav-item border-0 rounded-0" (click)="child.onClick($event); userMenu.hide()"
                            (keyup.enter)="child.onClick($event); userMenu.hide()" tabindex="0" role="button" aria-label="Menu item"
                            *ngFor="let child of menu.children">
                            <a class="nav-link">
                              <svg-icon *ngIf="child.src" [src]="child.src"></svg-icon>
                              <i *ngIf="child.iconClass" [class]="child.iconClass" style="font-size: large"></i>
                              <span>{{ child.label | translate }}</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li class="nav-item rai-menu-item"
                      *ngIf="((curPage | async) === 'settings' || (curPage | async) === 'dashboards') && isBetaAccessEnabled">
                      <a class="nav-link" (click)="toggleRaiMode(); userMenu.hide()" (keyup.enter)="toggleRaiMode(); userMenu.hide()"
                        tabindex="0" aria-label="Toggle RAI Mode">
                        <i [class]="raiModeEnabledForUser ? 'fa fa-toggle-on text-primary' : 'fa fa-toggle-off'"
                          style="width: 1.25rem; font-size: 1.25rem; margin-left: 0.4rem; text-align: center"></i>
                        <span>Built with Vibe</span>
                      </a>
                    </li>

                    <li class="nav-item">
                      <a class="nav-link" (click)="triggerLogout(); userMenu.hide()" (keyup.enter)="triggerLogout(); userMenu.hide()"
                        tabindex="0" aria-label="Logout">
                        <svg-icon src="assets/images/svg/logout.svg"></svg-icon>
                        <span>{{ 'LOGOUT' | translate }}</span>
                      </a>
                    </li>
                  </ul>
                </p-popover>
              </div>

              </div>
              </div>
              </div>

        <button
          class="icon-btn search-icon-btn ml-2"
          disabled
          title="{{ 'SEARCH' | translate }} (Ctrl + K)"
          *ngIf="
            (curPage | async) !== 'settings' &&
            (curPage | async) !== 'dashboards' &&
            isBetaAccessPrivilegeConsumableForApp
          "
        >
          <app-search-icon width="20" height="20"></app-search-icon>
        </button>

        <button
          class="icon-btn preview-icon-btn ml-2"
          [class.active]="activeArtifactTab === 'preview'"
          [class.invisible]="activeArtifactTab === 'code'"
          (click)="switchArtifactTab('preview')"
          title="Preview"
          type="button"
          [disabled]="config.flags.isApp_MergeStatus_InProgress"
          *ngIf="
            (curPage | async) !== 'settings' &&
            (curPage | async) !== 'dashboards' &&
            isBetaAccessPrivilegeConsumableForApp
          "
        >
          <app-play-icon [width]="19" [height]="19"></app-play-icon>
          <span class="preview-text">Preview</span>
        </button>

        <div
          class="dropdown publish-menu publish-trigger-container"
          *ngIf="
            (curPage | async) !== 'settings' &&
            (curPage | async) !== 'dashboards' &&
            isBetaAccessPrivilegeConsumableForApp
          "
          [class.menu-disabled]="config.flags.isApp_MergeStatus_InProgress || showProgressBar"
        >
          <button
            class="icon-btn publish-icon-btn ml-2"
            type="button"
            id="dropdownPublishV2"
            data-toggle="dropdown"
            data-display="static"
            aria-haspopup="true"
            aria-expanded="false"
            (click)="getPublishStatus()"
            [disabled]="showProgressBar || config.flags.isApp_MergeStatus_InProgress"
          >
            <app-publish-app *ngIf="!showProgressBar" width="19" height="19"></app-publish-app>
            <vb-app-loader-animated
            *ngIf="showProgressBar"
            class="publish-loading-spinner compact-loader"
          ></vb-app-loader-animated>
            <span class="publish-text">Publish</span>
          </button>

          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownPublishV2">
            <!-- Progress Status Items -->
            <ng-container *ngIf="showProgressBar">
              <div class="dropdown-item" *ngIf="lastPublishData?.prototype">
                <div class="d-flex flex-column menu-item">
                  <span class="menu-btn">{{ 'PUBLISH_PROTOTYPE' | translate }}</span>
                  <div class="d-flex justify-content-between status-info align-items-center">
                    <div class="left-content align-items-center">
                      <span>{{ 'PROTOTYPE_PUBLISH_PROGRESS' | translate }}</span>
                    </div>
                    <div class="ml-2 right-content align-items-center">
                      <span
                        class="status-label"
                        [class.in-progress]="lastPublishData.prototype.compilationStatus !== 'COMPILATION_SUCCESS'"
                        [class.completed]="lastPublishData.prototype.compilationStatus === 'COMPILATION_SUCCESS'"
                      >
                        {{
                          (lastPublishData.prototype.compilationStatus !== 'COMPILATION_SUCCESS'
                            ? 'IN_PROGRESS'
                            : 'COMPLETED'
                          ) | translate
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dropdown-item" *ngIf="lastPublishData?.push || lastPublishData?.prototype">
                <div class="d-flex flex-column menu-item">
                  <span class="menu-btn">{{ 'PUBLISH_CODE_GIT' | translate }}</span>
                  <div class="publish-sub-options-active">
                    <div
                      class="d-flex justify-content-between align-items-center sub-option"
                      *ngIf="lastPublishData?.push"
                    >
                      <div class="left-content align-items-center">
                        <span>{{ 'GIT_PUBLISH_PROGRESS' | translate }}</span>
                      </div>
                      <div class="ml-2 right-content align-items-center">
                        <span
                          class="status-label"
                          [class.in-progress]="lastPublishData.push.generationStatus !== 'PUBLISH_COMPLETED'"
                          [class.completed]="lastPublishData.push.generationStatus === 'PUBLISH_COMPLETED'"
                        >
                          {{
                            (lastPublishData.push.generationStatus !== 'PUBLISH_COMPLETED'
                              ? 'IN_PROGRESS'
                              : 'COMPLETED'
                            ) | translate
                          }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-between align-items-center sub-option"
                      *ngIf="lastPublishData?.push"
                    >
                      <div class="left-content align-items-center">
                        <span>{{ 'PROTOTYPE_PUBLISH_PROGRESS' | translate }}</span>
                      </div>
                      <div class="ml-2 right-content align-items-center">
                        <span
                          class="status-label"
                          [class.in-progress]="lastPublishData.push.compilationStatus !== 'COMPILATION_SUCCESS'"
                          [class.completed]="lastPublishData.push.compilationStatus === 'COMPILATION_SUCCESS'"
                        >
                          {{
                            (lastPublishData.push.compilationStatus !== 'COMPILATION_SUCCESS'
                              ? 'IN_PROGRESS'
                              : 'COMPLETED'
                            ) | translate
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="dropdown-item"
                *ngIf="lastPublishData?.uiLibPush && godeGenerationAction === 'PUSH_UI_LIBRARIES'"
              >
                <div class="d-flex flex-column menu-item">
                  <span class="menu-btn">{{ 'PUBLISH_UI_LIB_GIT' | translate }}</span>
                  <div class="d-flex justify-content-between status-info align-items-center">
                    <div class="left-content align-items-center">
                      <span>{{ 'UI_LIB_PUBLISH_PROGRESS' | translate }}</span>
                    </div>
                    <div class="ml-2 right-content align-items-center">
                      <span
                        class="status-label"
                        [class.in-progress]="lastPublishData.uiLibPush.generationStatus !== 'PUBLISH_COMPLETED'"
                        [class.completed]="lastPublishData.uiLibPush.generationStatus === 'PUBLISH_COMPLETED'"
                      >
                        {{
                          (lastPublishData.uiLibPush.generationStatus !== 'PUBLISH_COMPLETED'
                            ? 'IN_PROGRESS'
                            : 'COMPLETED'
                          ) | translate
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="dropdown-item"
                *ngIf="lastPublishData?.beLibPush && godeGenerationAction === 'PUSH_BE_LIBRARIES'"
              >
                <div class="d-flex flex-column menu-item">
                  <span class="menu-btn">{{ 'PUBLISH_BE_LIB_GIT' | translate }}</span>
                  <div class="d-flex justify-content-between status-info align-items-center">
                    <div class="left-content align-items-center">
                      <span>{{ 'BE_LIB_PUBLISH_PROGRESS' | translate }}</span>
                    </div>
                    <div class="ml-2 right-content align-items-center">
                      <span
                        class="status-label"
                        [class.in-progress]="lastPublishData.beLibPush.generationStatus !== 'PUBLISH_COMPLETED'"
                        [class.completed]="lastPublishData.beLibPush.generationStatus === 'PUBLISH_COMPLETED'"
                      >
                        {{
                          (lastPublishData.beLibPush.generationStatus !== 'PUBLISH_COMPLETED'
                            ? 'IN_PROGRESS'
                            : 'COMPLETED'
                          ) | translate
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dropdown-item" *ngIf="lastPublishData?.pull">
                <div class="d-flex flex-column menu-item">
                  <span class="menu-btn">{{ 'GET_CUSTOMIZATION_GIT' | translate }}</span>
                  <div class="d-flex justify-content-between status-info align-items-center">
                    <div class="left-content align-items-center">
                      <span>{{ 'GIT_PULL' | translate }}</span>
                    </div>
                    <div class="ml-2 right-content align-items-center">
                      <span
                        class="status-label"
                        [class.in-progress]="lastPublishData.pull.generationStatus !== 'PUBLISH_COMPLETED'"
                        [class.completed]="lastPublishData.pull.generationStatus === 'PUBLISH_COMPLETED'"
                      >
                        {{
                          (lastPublishData.pull.generationStatus !== 'PUBLISH_COMPLETED' ? 'IN_PROGRESS' : 'COMPLETED')
                            | translate
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Normal Last Publish Items (only if not publishing) -->
            <ng-container *ngIf="!showProgressBar">
              <div class="dropdown-item">
                <div
                  class="d-flex flex-column menu-item"
                  (click)="showConfirmPublish('PROTOTYPE')"
                  (keyup.enter)="showConfirmPublish('PROTOTYPE')"
                  tabindex="0"
                  role="button"
                  aria-label="Confirm Publish"
                >
                  <button class="menu-btn" type="button">{{ 'PUBLISH_PROTOTYPE' | translate }}</button>
                  <div
                    class="d-flex justify-content-between last-publish align-items-center"
                    *ngIf="lastCompletedPublishData?.prototype"
                  >
                    <div class="left-content align-items-center">
                      <span>{{ 'LAST_PUBLISH' | translate }}</span>
                    </div>
                    <div class="ml-2 right-content align-items-center">
                      <span class="mr-1">{{
                        lastCompletedPublishData.prototype.modifiedDate | date: 'MMM d, hh:mm a'
                      }}</span>
                      <p-avatar
                        [label]="lastCompletedPublishData?.prototype?.avatarImage?.character"
                        shape="circle"
                        pTooltip="{{ lastCompletedPublishData.prototype.name }}"
                        tooltipPosition="bottom"
                        [style]="{
                          'background-color': lastCompletedPublishData?.prototype?.avatarImage?.color,
                          color: '#fff'
                        }"
                        appendTo="body"
                      ></p-avatar>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dropdown-item">
                <div
                  class="d-flex flex-column menu-item publish-code-git-item"
                  (click)="showConfirmPublish('PUSH')"
                  (keyup.enter)="showConfirmPublish('PUSH')"
                  tabindex="0"
                  role="menuitem"
                >
                  <button class="menu-btn" type="button">{{ 'PUBLISH_CODE_GIT' | translate }}</button>
                  <div
                    class="publish-sub-options"
                    role="menu"
                    *ngIf="lastCompletedPublishData?.push || lastCompletedPublishData?.prototype"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center sub-option"
                      *ngIf="lastCompletedPublishData?.push"
                      aria-label="Git Publish - Push code to Git repository"
                    >
                      <div class="left-content align-items-center">
                        <span>{{ 'GIT_PUBLISH' | translate }}</span>
                      </div>
                      <div class="ml-2 right-content align-items-center">
                        <span class="mr-1">{{
                          lastCompletedPublishData.push.modifiedDate | date: 'MMM d, hh:mm a'
                        }}</span>
                        <p-avatar
                          [label]="lastCompletedPublishData?.push?.avatarImage?.character"
                          shape="circle"
                          pTooltip="{{ lastCompletedPublishData.push.name }}"
                          tooltipPosition="bottom"
                          [style]="{
                            'background-color': lastCompletedPublishData?.push?.avatarImage?.color,
                            color: '#fff'
                          }"
                          appendTo="body"
                        ></p-avatar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dropdown-item">
                <div
                  class="menu-item"
                  (click)="showConfirmPublish('PULL')"
                  (keyup.enter)="showConfirmPublish('PULL')"
                  tabindex="0"
                  role="button"
                  aria-label="Show Confirm Publish"
                >
                  <button class="menu-btn" type="button">{{ 'GET_CUSTOMIZATION_GIT' | translate }}</button>
                  <div
                    class="d-flex justify-content-between last-publish align-items-center"
                    *ngIf="lastCompletedPublishData?.pull"
                  >
                    <div class="left-content align-items-center">
                      <span>{{ 'LAST_PULL' | translate }}</span>
                    </div>
                    <div class="ml-2 right-content align-items-center">
                      <span class="mr-1">{{
                        lastCompletedPublishData.pull.modifiedDate | date: 'MMM d, hh:mm a'
                      }}</span>
                      <p-avatar
                        [label]="lastCompletedPublishData?.pull?.avatarImage?.character"
                        shape="circle"
                        pTooltip="{{ lastCompletedPublishData.pull.name }}"
                        tooltipPosition="bottom"
                        [style]="{
                          'background-color': lastCompletedPublishData?.pull?.avatarImage?.color,
                          color: '#fff'
                        }"
                        appendTo="body"
                      ></p-avatar>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dropdown-item">
                <div
                  class="menu-item"
                  (click)="showConfirmPublish('PUSH_UI_LIBRARIES')"
                  (keyup.enter)="showConfirmPublish('PUSH_UI_LIBRARIES')"
                  tabindex="0"
                  aria-label="Publish UI Libraries to Git"
                  [pTooltip]="'PUBLISH_UI_LIB_GIT_TOOLTIP' | translate: { version: productVersion }"
                  tooltipPosition="left"
                  tooltipStyleClass="publish-lib-tooltip"
                  appendTo="body"
                  showDelay="200"
                  hideDelay="100"
                >
                  <button class="menu-btn" type="button">
                    {{ 'PUBLISH_UI_LIB_GIT' | translate }}
                  </button>
                  <div
                    class="d-flex justify-content-between last-publish align-items-center"
                    *ngIf="lastCompletedPublishData?.uiLibPush"
                  >
                    <div class="left-content align-items-center">
                      <span>{{ 'LAST_PUBLISH' | translate }}</span>
                    </div>
                    <div class="ml-2 right-content align-items-center">
                      <span class="mr-1">{{
                        lastCompletedPublishData.uiLibPush.modifiedDate | date: 'MMM d, hh:mm a'
                      }}</span>
                      <p-avatar
                        pTooltip="{{ lastCompletedPublishData.uiLibPush.name }}"
                        tooltipPosition="bottom"
                        [label]="lastCompletedPublishData?.uiLibPush?.avatarImage?.character"
                        shape="circle"
                        [style]="{
                          'background-color': lastCompletedPublishData?.uiLibPush?.avatarImage?.color,
                          color: '#fff'
                        }"
                        appendTo="body"
                      ></p-avatar>
                    </div>
                  </div>
                  <div class="lib-publish-info" *ngIf="productVersion">
                    <i class="pi pi-info-circle"></i>
                    <span>{{ 'PUBLISH_UI_LIB_GIT_TOOLTIP' | translate: { version: productVersion } }}</span>
                  </div>
                </div>
              </div>
              <div class="dropdown-item">
                <div
                  class="menu-item"
                  (click)="showConfirmPublish('PUSH_BE_LIBRARIES')"
                  (keyup.enter)="showConfirmPublish('PUSH_BE_LIBRARIES')"
                  tabindex="0"
                  aria-label="Publish Backend Libraries to Git"
                  [pTooltip]="'PUBLISH_BE_LIB_GIT_TOOLTIP' | translate: { version: beLibraryVersion }"
                  tooltipPosition="left"
                  tooltipStyleClass="publish-lib-tooltip"
                  appendTo="body"
                  showDelay="200"
                  hideDelay="100"
                >
                  <button class="menu-btn" type="button">
                    {{ 'PUBLISH_BE_LIB_GIT' | translate }}
                  </button>
                  <div
                    class="d-flex justify-content-between last-publish align-items-center"
                    *ngIf="lastCompletedPublishData?.beLibPush"
                  >
                    <div class="left-content align-items-center">
                      <span>{{ 'LAST_PUBLISH' | translate }}</span>
                    </div>
                    <div class="ml-2 right-content align-items-center">
                      <span class="mr-1">{{
                        lastCompletedPublishData.beLibPush.modifiedDate | date: 'MMM d, hh:mm a'
                      }}</span>
                      <p-avatar
                        pTooltip="{{ lastCompletedPublishData.beLibPush.name }}"
                        tooltipPosition="bottom"
                        [label]="lastCompletedPublishData?.beLibPush?.avatarImage?.character"
                        shape="circle"
                        [style]="{
                          'background-color': lastCompletedPublishData?.beLibPush?.avatarImage?.color,
                          color: '#fff'
                        }"
                        appendTo="body"
                      ></p-avatar>
                    </div>
                  </div>
                  <div class="lib-publish-info" *ngIf="beLibraryVersion">
                    <i class="pi pi-info-circle"></i>
                    <span>{{ 'PUBLISH_BE_LIB_GIT_TOOLTIP' | translate: { version: beLibraryVersion } }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div
          class="dropdown settings-menu ml-2"
          *ngIf="
            (curPage | async) !== 'settings' &&
            (curPage | async) !== 'dashboards' &&
            isBetaAccessPrivilegeConsumableForApp"
        >
          <button
            class="icon-btn dots-horizontal-btn"
            type="button"
            id="dropdownSettingsV2"
            data-toggle="dropdown"
            data-display="static"
            aria-haspopup="true"
            aria-expanded="false"
            [disabled]="config.flags.isApp_MergeStatus_InProgress"
            tooltip="More settings"
          >
            <div class="dots-horizontal-icon"></div>
          </button>

          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownSettingsV2">
            <div class="dropdown-item">
              <div
                class="d-flex align-items-center menu-item settings-menu-item"
                (click)="viewNotification()"
                (keyup.enter)="viewNotification()"
                tabindex="0"
                role="menuitem"
                aria-label="{{ 'NOTIFICATIONS' | translate }}"
              >
                <div class="settings-menu-icon">
                  <svg-icon src="assets/designIconLib/SVG/bell-01.svg"></svg-icon>
                </div>
                <span class="settings-menu-label">{{ 'PUBLISH_NOTIFICATION' | translate }}</span>
              </div>
            </div>
            <div class="dropdown-item">
              <div
                class="d-flex align-items-center menu-item settings-menu-item"
                (click)="navigateToAppSettings()"
                (keyup.enter)="navigateToAppSettings()"
                tabindex="0"
                role="menuitem"
                aria-label="App Settings"
              >
                <div class="settings-menu-icon">
                  <rt-icon-settings-01 [width]="16" [height]="16"></rt-icon-settings-01>
                </div>
                <span class="settings-menu-label">{{ 'APP_SETTINGS' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-group rhs-actions profile-flyout-for-beta-access-user" *ngIf="isBetaAccessPrivilegeConsumable">
      <a
        aria-expanded="false"
        class="p-0 btn"
        tabindex="0"
        (click)="menu.toggle($event)"
        (keydown.enter)="menu.toggle($event)"
      >
        <p-avatar
          class="user-avatar-icon"
          [label]="avatarImage?.character"
          shape="circle"
          [style]="{ 'background-color': avatarImage?.color }"
          (onFilter)="searchOrg($event)"
          showDelay="100"
          hideDelay="100"
          pTooltip="{{ loggedInUser }}"
          tooltipStyleClass="label-tooltip custom-tooltip-header-avatar"
          tooltipPosition="left"
          appendTo="body"
        ></p-avatar>
      </a>
      <p-menu #menu [model]="userMenuItems" [popup]="true" appendTo="body" styleClass="user-profile-menu">
        <ng-template pTemplate="item" let-item>
          <a
            *ngIf="!item.separator"
            class="p-menu-item-link"
            [ngClass]="item.styleClass"
            (click)="menu.itemClick($event, item)"
            (keydown.enter)="menu.itemClick($event, item)"
            tabindex="0"
            [attr.data-pc-section]="'action'"
          >
            <!-- Custom Angular SVG Icons with inherited color wrapped in standard span -->
            <rt-icon-cloud *ngIf="item.icon === 'cloud'" class="p-menu-item-icon custom-svg-icon"></rt-icon-cloud>
            <rt-icon-billing-home
              *ngIf="item.icon === 'billing-home'"
              class="p-menu-item-icon custom-svg-icon"
            ></rt-icon-billing-home>

            <!-- Standard PrimeNG Icons -->
            <span
              *ngIf="item.icon !== 'cloud' && item.icon !== 'billing-home' && item.icon"
              class="p-menu-item-icon"
              [ngClass]="item.icon"
            ></span>

            <span class="p-menu-item-label">{{ item.label }}</span>
          </a>
        </ng-template>
      </p-menu>
    </div>
  </div>
</div>

<vb-blocker
  [blocked]="true"
  [isDisplayed]="blockedDocument"
  [blockerType]="blockerType"
  [message]="blockedMessage"
  [positionCentered]="true"
  [displayMessageAfter]="100"
  [data]="blockerData"
></vb-blocker>

<!-- Publishing Dialogs -->
<p-dialog
  [(visible)]="showPublishStatus"
  styleClass="cloud publish-status-model"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '50vw' }"
>
  <ng-template #header>
    <div class="d-flex flex-prototype">
      <ng-container *ngIf="generationApiStatus === 'success'">
        {{ actionHeader }}{{ 'PUBLISH_SUCCESSFUL' | translate }}
      </ng-container>
      <ng-container
        *ngIf="
          generationApiStatus === 'warning' ||
          generationApiStatus === 'error' ||
          generationApiStatus === 'apiError' ||
          generationApiStatus === 'anotherGeneration'
        "
      >
        {{ actionHeader }}{{ 'PUBLISH_NOT_SUCCESSFUL' | translate }}
      </ng-container>
    </div>
  </ng-template>
  <div class="p-4 d-flex align-items-center">
    <span class="status-icon">
      <ng-container *ngIf="generationApiStatus === 'success'">
        <i class="pi pi-check-circle" aria-hidden="true" style="color: #22c55e; font-size: 2rem"></i>
      </ng-container>
      <ng-container *ngIf="generationApiStatus === 'warning' || generationApiStatus === 'taskExecutionInProgress'">
        <i class="pi pi-exclamation-triangle" aria-hidden="true" style="color: #f59e0b; font-size: 2rem"></i>
      </ng-container>
      <ng-container
        *ngIf="
          generationApiStatus === 'error' ||
          generationApiStatus === 'apiError' ||
          generationApiStatus === 'anotherGeneration'
        "
      >
        <i class="pi pi-exclamation-circle" aria-hidden="true" style="color: #ef4444; font-size: 2rem"></i>
      </ng-container>
    </span>
    <p class="ml-3">
      <ng-container *ngIf="generationApiStatus === 'success'">
        <ng-container [ngSwitch]="godeGenerationAction">
          <ng-container *ngSwitchCase="'PROTOTYPE'">
            {{ 'PROTOTYPE_PUBLISH_SUCCESS_MSG' | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="'PUSH_UI_LIBRARIES'">
            {{ action }}{{ 'PUBLISH_SUCCESS_MSG' | translate }}
          </ng-container>
          <ng-container *ngSwitchCase="'PUSH_BE_LIBRARIES'">
            {{ action }}{{ 'PUBLISH_SUCCESS_MSG' | translate }}
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ action }}{{ 'PUBLISH_SUCCESS_MSG' | translate }}
            <ng-container *ngIf="compilationFailed === null">
              {{ 'LATEST_CHANGES_AVAILABLE' | translate }}
            </ng-container>
            <ng-container *ngIf="compilationFailed === false">
              {{ 'PROTOTYPE_PUBLISH_SUCCESS_MSG' | translate }}
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container
          *ngIf="
            compilationFailed === false ||
            (compilationFailed === null &&
              godeGenerationAction !== 'PUSH_UI_LIBRARIES' &&
              godeGenerationAction !== 'PUSH_BE_LIBRARIES')
          "
        >
          <a href="{{ prototypingAppUrl }}" target="_blank" class="prototype-link"
            >{{ 'PROTOTYPE_VIEW' | translate }}
          </a>
        </ng-container>
        <ng-container *ngIf="showNotification">
          <br />
          {{ 'WARNINGS_DURING_PUBLISHING' | translate }}
        </ng-container>
        <ng-container *ngIf="compilationFailed">
          {{ 'COMPILATION_DURING_GENERATION' | translate }}
          <a href="javascript:void(0)" (click)="getCloudBuildLog()" class="prototype-link">{{
            'CLICK_HERE' | translate
          }}</a>
          {{ 'TO_VIEW_LOGS' | translate }}
        </ng-container>
      </ng-container>
      <ng-container *ngIf="generationApiStatus === 'warning'">
        {{ 'PUBLISH_WARN_MSG' | translate }}
      </ng-container>
      <ng-container *ngIf="generationApiStatus === 'error'">
        {{ action }}{{ 'PUBLISH_ERR_MSG' | translate }}
        <ng-container *ngIf="compilationFailed">
          {{ 'COMPILATION_DURING_GENERATION' | translate }}
          <a href="javascript:void(0)" (click)="getCloudBuildLog()" target="_blank" class="prototype-link">{{
            'CLICK_HERE' | translate
          }}</a>
          {{ 'TO_VIEW_LOGS' | translate }}
        </ng-container>
      </ng-container>
      <ng-container *ngIf="generationApiStatus === 'apiError'">
        {{ generationApiError }}
      </ng-container>
      <ng-container *ngIf="generationApiStatus === 'anotherGeneration'">
        <p class="mb-1">
          <b>{{ 'DESCRIPTION' | translate }}</b>
          {{ 'REQUEST_CANNOT_PROCESS_BECAUSE_OF_ANOTHER_GENERATION_PROCESS' | translate }}
        </p>
        <p>
          <b>{{ 'POSSIBLE_ACTIONS:' | translate }}</b>
        </p>
        <p>{{ 'WAIT_FOR_COMPLETION' | translate }}</p>
        <p>{{ 'CHECK_PROTOTYPE_STATUS' | translate }}</p>
        <p>{{ 'GIT_OPERATIONS' | translate }}</p>
      </ng-container>
      <ng-container *ngIf="generationApiStatus === 'taskExecutionInProgress'">
        <p class="mb-1">
          {{ 'TASK_EXECUTION_IN_PROGRESS' | translate }}
        </p>
      </ng-container>
    </p>
  </div>
  <ng-template #footer>
    <div class="text-right update-form">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closePopup()">
        {{ 'CLOSE' | translate }}
      </button>
      <button pButton pRipple class="btn btn-primary" (click)="viewNotification()" *ngIf="showNotification">
        {{ 'VIEW_NOTIFICATION_LIST' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showLogPopUp"
  styleClass="cloud"
  [style]="{ width: '70vw', height: '89vh', overflow: 'hidden', padding: '0px' }"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
>
  <ng-template #header>
    <div class="d-flex flex-prototype" style="flex-direction: column">
      {{ 'CLOUD_BUILD_LOGS' | translate }}
      <span id="header">{{ headerMsg }}</span>
    </div>
  </ng-template>
  <div
    class="logs p-2"
    style="overflow-y: auto; max-height: calc(89vh - 120px); background: #1e1e1e; color: #fff; font-family: monospace"
  >
    <div class="d-flex subLogs" *ngFor="let cloudBuildLog of logsArray; let i = index">
      <span class="log-num mr-1" style="color: #858585; min-width: 30px; text-align: right">{{ i + 1 }}</span>
      <p id="cloud-logs" class="mb-0" style="white-space: pre-wrap">
        {{ cloudBuildLog }}
      </p>
    </div>
  </div>
  <ng-template #footer>
    <div class="text-right update-form">
      <button type="button" class="btn btn-secondary cancel-btn" (click)="closePopup()">
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="confirmPublish"
  styleClass="publish-status-model"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '30vw' }"
>
  <ng-template #header>
    <div class="d-flex flex-prototype">
      {{ 'CONFIRMATION' | translate }}
    </div>
  </ng-template>
  <div class="p-2 d-flex align-items-center">
    <span class="status-icon">
      <i class="pi pi-exclamation-triangle" style="color: #f59e0b; font-size: 2rem"></i>
    </span>
      <div
        class="d-flex align-items-cente pl-3 mt-2"
        *ngIf="godeGenerationAction !== 'PUSH_UI_LIBRARIES' && godeGenerationAction !== 'PUSH_BE_LIBRARIES'"
      >
        <p-checkbox
          [(ngModel)]="allowPublishWarn"
          [binary]="true"
          inputId="binary"
          id="allowPublishWarn"
          (onChange)="checkboxChange($event)"
          styleClass="mr-1"
        ></p-checkbox>
        <label class="mb-0" for="allowPublishWarn" [ngClass]="{ 'highlight-label': allowPublishWarn }">{{
          'PUBLISH_WITH_WARNINGS' | translate
        }}</label>
      </div>
    </div>
  <ng-template #footer>
    <div class="text-right update-form">
      <p-button
        pRipple
        type="button"
        label="{{ 'NO' | translate }}"
        styleClass="btn btn-secondary cancel-btn"
        (onClick)="closeConfirm()"
      />
      <p-button
        pRipple
        type="button"
        label="{{ 'YES' | translate }}"
        styleClass="btn btn-primary btn-yes"
        (onClick)="codeGeneration()"
      />
    </div>
  </ng-template>
</p-dialog>

<div class="warning-container" *ngIf="showPrototypePopup">
  <span
    class="close-btn"
    tabindex="0"
    role="button"
    (click)="showPrototypePopup = !showPrototypePopup"
    (keydown.enter)="showPrototypePopup = !showPrototypePopup"
    >&times;</span
  >
  <span>Warning: Application Prototype Unavailable</span>
  <div class="p-2 d-flex align-items-center">
    <span class="status-icon">
      <i class="pi pi-exclamation-triangle"></i>
    </span>
    <div class="pl-4 d-flex align-items-left flex-column justify-content-center flex-grow-1">
      It is in the process of being published.
    </div>
  </div>
</div>

<p-dialog
  class="form p-dialog"
  header="{{ 'WARNING' | translate }}"
  [(visible)]="showWarnAppPop"
  [baseZIndex]="10000"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  styleClass="roles-map"
>
  <div class="p-4 d-flex align-items-center">
    <span class="status-icon">
      <i class="pi pi-exclamation-triangle" aria-hidden="true" style="color: #f59e0b"></i>
    </span>
    <p class="ml-3">
      {{ 'APPL_WARN' | translate
      }}<a href="{{ nosqlRappitLink }}" target="_blank" class="prototype-link ml-1">{{ nosqlRapLinkName }}</a>
    </p>
  </div>
  <ng-template #footer>
    <div class="text-right update-form">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeWarnPopup()">
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Merge Details Confirmation Dialog -->
<p-confirmDialog
  key="mergeDetailsPopup"
  [closable]="true"
  [closeOnEscape]="true"
  appendTo="body"
  styleClass="merge-details-popup"
>
  <ng-template pTemplate="message">
    <div class="merge-details-content">
      <div class="merge-info-row">
        <span class="merge-label">{{ 'INITIATED_BY' | translate }}</span>
        <span class="merge-value">{{ mergeStatusInfo?.initiatedBy }}</span>
      </div>
      <div class="merge-info-row">
        <span class="merge-label">{{ 'STATUS' | translate }}:</span>
        <span class="merge-value status-badge" *ngIf="mergeStatusInfo?.status === 'MERGE_CHANGES_REVIEW_IN_PROGRESS'">{{
          'MERGE_REVIEW_IN_PROGRESS' | translate
        }}</span>
        <span
          class="merge-value status-badge status-processing"
          *ngIf="mergeStatusInfo?.status === 'MERGE_PROCESS_IN_PROGRESS'"
          >{{ 'MERGE_IN_PROGRESS' | translate }}</span
        >
      </div>
      <div class="merge-warning">
        <i class="pi pi-info-circle"></i>
        <span [innerHTML]="'MERGE_VIEW_ONLY_MESSAGE' | translate: { role: getMergeBranchRole() }"></span>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<!-- Cancel Merge Confirmation Dialog -->
<p-confirmDialog key="cancelMergeConfirmation" [closable]="true" [closeOnEscape]="true" appendTo="body">
</p-confirmDialog>
